import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import settings from '../public/settings.json';
import store from './store'
import axios from 'axios'
import 'regenerator-runtime/runtime'



Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



const baseAPI = axios.create({
  baseURL: settings.apiURL
});

const UNAUTHORIZED = 401;


Vue.mixin({
  data() {
    return {
      lastActivity: Date.now()
    };
  },
  mounted() {
    document.addEventListener('mousemove', this.updateLastActivity);
    document.addEventListener('keypress', this.updateLastActivity);
  
    this.timer = setInterval(() => {
      const elapsedTime = Date.now() - this.lastActivity;
      if (elapsedTime >= 24 * 60 * 60 * 1000) {
        clearInterval(this.timer);
        // Log the user out
      }
    }, 5000);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.updateLastActivity);
    document.removeEventListener('keypress', this.updateLastActivity);
  
    clearInterval(this.timer);
  },
  methods: {
    GetBaseUrl() {
      return settings.apiURL;
    },
    updateLastActivity() {
      this.lastActivity = Date.now();
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 202) {
            return true;
          } else
            return false;
        });
    },
    // GoToLogin() {
    //   let path = this.$router.currentRoute.path;
    //   if (path.toLowerCase() != "/login") {

    //     this.$router.push({
    //       path: '/Login',
    //       query: {
    //         targetUrl: this.$router.currentRoute.fullPath,
    //       }
    //     })

    //   }
    // },
    GoToSignUp() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/index") {
        this.$router.push("/Index");
      }
    },
    GoToHome() {
      this.$router.push("/Dashboard");
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });

    },
    GoToDashboard() {
      this.$router.push("/Dashboard");
    },
    GoToLogin() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/login") {

        this.$router.push({
          path: '/Login',
          query: {
            targetUrl: this.$router.currentRoute.fullPath,
          }
        })

      }
    },
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.users = response.data;
            console.log(":testing" + this.users.id);
          }
        });
    },
  }

})

baseAPI.interceptors.response.use(response => response, error => {
  const {
    status
  } = error.response;
  if (status == UNAUTHORIZED) {
    router.push("/Login");
  } else {
    console.log("test");
  }
  return Promise.reject(error);
  //
})

Vue.prototype.$API = baseAPI

Vue.prototype.$SignOut = 'kiddo/SignOut'
Vue.prototype.$GetUserToken = 'kiddo/GetTuitionOwner'

Vue.prototype.$EditSchedule = 'kiddo/Read/ScheduleDetails'
Vue.prototype.$DuplicateSchedule = 'kiddo/Read/ScheduleToDuplicate'
Vue.prototype.$GetListSubject = 'kiddo/Read/ScheduleSubjectList'
Vue.prototype.$GetListSubjectCopy = 'kiddo/Read/ScheduleSubjectListCopy'
Vue.prototype.$ProfileTeacher = 'kiddo/Read/TeacherProfile'
Vue.prototype.$ProfessionalTeacher = 'kiddo/Read/TeacherProfessional'
Vue.prototype.$ListSubject = 'kiddo/Read/SubjectList'
Vue.prototype.$ListGrade = 'kiddo/Read/GradeList'
Vue.prototype.$ListTeacher = 'kiddo/Read/FindTutorTeacherList'
Vue.prototype.$FilterTeacher = 'kiddo/Read/FilterTeacher'
Vue.prototype.$ListChild = 'kiddo/Read/ListChild'
Vue.prototype.$UserType = 'kiddo/Read/StatusUserType'
Vue.prototype.$DetailParent = 'kiddo/Read/DetailParent'
Vue.prototype.$AllWaitingList = 'kiddo/Read/GetWaitingList'
Vue.prototype.$Request = 'kiddo/Read/GetRequest'
Vue.prototype.$RequestNotificationStudent = 'kiddo/Read/RequestNotificationStudent'
Vue.prototype.$CheckStatusJob = 'kiddo/Read/CheckingStatusJob'
Vue.prototype.$CheckTutorJob = 'kiddo/Read/CheckingTutorJob'
Vue.prototype.$Faq = 'kiddo/Read/GetFaq'
Vue.prototype.$AnswerFaqById = 'kiddo/Read/GetFaqById'
Vue.prototype.$InsertFindTutors = 'kiddo/Insert/SearchTutor'
Vue.prototype.$SignOut = 'kiddo/Insert/SignOut'
Vue.prototype.$UserAuth = 'kiddo/Insert/IsAuthenticated'
Vue.prototype.$SignUp = 'kiddo/Insert/Register'
Vue.prototype.$Blog = 'kiddo/Read/ListBlog'
Vue.prototype.$BlogById = 'kiddo/Read/ListBlogById'
Vue.prototype.$News = 'kiddo/Read/GetArticleSome'

Vue.prototype.$AllStudentName = 'kiddo/Read/AllStudentName'
Vue.prototype.$FindtutorFullDetails = 'kiddo/Read/CheckFullFindTutor'
Vue.prototype.$NotificationTeacher = 'kiddo/Read/NotificationTeacher'
Vue.prototype.$NotificationStudent = 'kiddo/Read/NotificationStudent'
Vue.prototype.$Languages = 'kiddo/Read/GetLanguage'
Vue.prototype.$Sessions = 'kiddo/Read/GetSession'
Vue.prototype.$Times = 'kiddo/Read/GetTime'
Vue.prototype.$Durations = 'kiddo/Read/GetDuration'
Vue.prototype.$DurationGroups = 'kiddo/Read/GetDurationGroup'
Vue.prototype.$ConfirmationClass = 'kiddo/Read/ConfirmationClass'
Vue.prototype.$ConfirmationClassStatus = 'kiddo/Read/CheckConfirmation'
Vue.prototype.$CheckStatusByFindTutorID = 'kiddo/Read/CheckStatusByFindTutorID'
Vue.prototype.$NotificationClassLanguage = 'kiddo/Read/NotificationClassLanguage'
Vue.prototype.$NotificationClassSession = 'kiddo/Read/NotificationClassSession'
Vue.prototype.$NotificationStudentResponse = 'kiddo/Read/NotificationStudentResponse'
Vue.prototype.$NotificationClassTime = 'kiddo/Read/NotificationClassTime'
Vue.prototype.$GetAcceptJob = 'kiddo/Read/GetAcceptJob'
Vue.prototype.$NotifyStudentJobAccepted = 'kiddo/Read/NotifyStudentJobAccepted'
Vue.prototype.$NotifyStudentTutorResponse = 'kiddo/Read/NotifyStudentTutorResponse'
Vue.prototype.$NotifyTeacherSetSchedule = 'kiddo/Read/NotifyTeacherSetSchedule'
Vue.prototype.$NotificationConfirmResponseStudent = 'kiddo/Read/NotificationConfirmResponseStudent'
Vue.prototype.$NotificationConfirmResponseToTeacher = 'kiddo/Read/NotificationConfirmResponseToTeacher'
Vue.prototype.$TeacherClassGrade = 'kiddo/Read/TeacherClassGrade'
Vue.prototype.$GetFindTutor = 'kiddo/Read/FindTutor'
Vue.prototype.$ListRequest = 'kiddo/Read/GetListRequest'
Vue.prototype.$FindTutorStudent = 'kiddo/Read/FindTutorStudent'
Vue.prototype.$NotificationTeacherSchedule = 'kiddo/read/NotificationTeacherSchedule'
Vue.prototype.$AllFindTutor = 'kiddo/Read/GetFindTutorAllId'
Vue.prototype.$TeacherByFindTutor = 'kiddo/Read/GetTeacherByFindTutorId'
Vue.prototype.$OfferDirectFindTutor = 'kiddo/Insert/OfferDirectToTeacher'
Vue.prototype.$NotificationAll = 'kiddo/read/AllNotificationLimitAuthorizeByWeb'
Vue.prototype.$NotificationAllDetail = 'kiddo/read/AllNotificationLimitAuthorizeByWebDetail'
Vue.prototype.$GetSubjectPackage = 'kiddo/read/GetSubjectPackage'
Vue.prototype.$AllClassPackage = 'kiddo/Read/AllClassPackage'
Vue.prototype.$PackageById = 'kiddo/Read/PackageById'
Vue.prototype.$GetListParent = 'kiddo/Read/GetListParent'
Vue.prototype.$GetStudentTcByPaginate = 'kiddo/Read/GetStudentTcByPaginate'


//Quiz
Vue.prototype.$CheckStudentSubGraStat = 'kiddo/Read/CheckStudentSubGraStat'
Vue.prototype.$StudentUpdateStatus = 'kiddo/Insert/StudentUpdateStatus'
Vue.prototype.$QuizSubjectList = 'kiddo/Read/QuizSubjectAll'
Vue.prototype.$QuizTeacherDetails = 'kiddo/Read/TeacherQuizGroupBySubject'
Vue.prototype.$QuizTeacherStatistics = 'kiddo/Read/TeacherQuizCountStudentAnswer'
Vue.prototype.$QuizTeacherPublishByQuiz = 'kiddo/Read/QuizTeacherPublishByQuiz'
Vue.prototype.$QuizGradeList = 'kiddo/Read/QuizGradeAll'
Vue.prototype.$QuizSummary = 'kiddo/Read/QuizSummary'
Vue.prototype.$QuizPreview = 'kiddo/Read/QuizPreview'
Vue.prototype.$QuizStartNumber = 'kiddo/Read/QuizNo'
Vue.prototype.$CreateQuizTitle = 'kiddo/Insert/TeacherCreateQuiz'
Vue.prototype.$CreateQuizQuestion = 'kiddo/Insert/InsertTeacherQuestion'
Vue.prototype.$QuizTeacherNewQuestion = 'kiddo/Insert/QuizTeacherNewQuestion'
Vue.prototype.$EditQuizQuestion = 'kiddo/Insert/EditTeacherQuestion'
Vue.prototype.$PublishQuiz = 'kiddo/Insert/QuizPublish'
Vue.prototype.$UploadPhoto = 'kiddo/FileTransfer/UploadQuizQuestion'
Vue.prototype.$UploadNewProduct = 'kiddo/FileTransfer/UploadNewProduct'
Vue.prototype.$GetUsersPayment = 'kiddo/Read/GetUserDatas'
Vue.prototype.$GetCheckPassword = 'kiddo/Read/checkPaymentPassword'
Vue.prototype.$EwalletDirectPayment = 'kiddo/Insert/EwalletDirectPayment'
Vue.prototype.$EwalletAmount = 'kiddo/Read/WalletAmount'
Vue.prototype.$PaymentListByStudent = 'kiddo/read/PaymentLists'
Vue.prototype.$ScheduleStudent = 'kiddo/read/SchedulesStudents'
Vue.prototype.$ScheduleStudentWeb = 'kiddo/read/SchedulesStudentsWeb'
Vue.prototype.$ScheduleStudentWebAll = 'kiddo/read/SchedulesStudentsWebAll'
Vue.prototype.$ReportCardByUserId = 'kiddo/read/ReportCardByUserId'
Vue.prototype.$QuizScoreByParent = 'kiddo/read/QuizStudentHistoryDetailByUserId'

Vue.prototype.$StudentStartQuiz = 'kiddo/Insert/QuizStartStudent'
Vue.prototype.$QuizQuestion = 'kiddo/Read/QuizStudentCurrentQues'
Vue.prototype.$StudentSubmitAnswer = 'kiddo/Insert/StudentSubmitAnswer'
Vue.prototype.$ListQuestion = 'kiddo/Read/ListQuestionByQuizId'
Vue.prototype.$StudentList = 'kiddo/Read/GetStudentListByParentId'
Vue.prototype.$ListTeacherQuizBySubjectId = 'kiddo/Read/ListTeacherQuizBySubjectId'
Vue.prototype.$QuizStudentDetail = 'kiddo/Read/StudentQuizGroupBySubjectId'
Vue.prototype.$ListStudentQuizBySubjectId = 'kiddo/Read/StudentQuizList'
Vue.prototype.$GetStudentFinalScore = 'kiddo/Read/GetStudentFinalScore'
Vue.prototype.$QuizStudentRecordBySubjectId = 'kiddo/Read/QuizStudentRecordBySubjectId'
Vue.prototype.$QuizStudentHistoryByQuiz = 'kiddo/Read/QuizStudentHistoryByQuiz'
Vue.prototype.$QuizStudentLeaderBoard = 'kiddo/Read/QuizStudentLeaderBoard'
Vue.prototype.$QuizTeacherLeaderBoard = 'kiddo/Read/QuizTeacherLeaderBoards'
Vue.prototype.$QuizStudentHistoryDetailByQuiz = 'kiddo/Read/QuizStudentHistoryDetailByQuiz'
Vue.prototype.$StudentProfile = 'kiddo/Read/GetStudentProfile'
Vue.prototype.$ParentProfile = 'kiddo/Read/ParentProfile'
Vue.prototype.$QuizStudentStatisticAverageScore = 'kiddo/Read/QuizStudentStatisticAverageScore'
Vue.prototype.$QuizTeacherStatisticTopRankStudents = 'kiddo/Read/QuizTeacherStatisticTopRankStudents'
Vue.prototype.$QuizTeacherStatisticQuizCount = 'kiddo/Read/QuizTeacherStatisticQuizCount'
Vue.prototype.$QuizTeacherStatisticTopQuizRank = 'kiddo/Read/QuizTeacherStatisticTopQuizRank'

//comment because of redundant api name


Vue.prototype.$GetQuestionDetail = 'kiddo/Read/GetQuestionDetail'
Vue.prototype.$LoginUserDetailWebs = 'kiddo/Read/LoginUserDetailWebs'
Vue.prototype.$LoginUserDetailAdmin = 'kiddo/Read/LoginUserDetailAdmin'
Vue.prototype.$StudentListAuthorize = 'kiddo/read/AllStudentListAuthorize'
Vue.prototype.$GetProfilePhotoAuthorize = 'kiddo/Read/GetProfilePhotoAuthorize'
Vue.prototype.$GetWalletListWeb = 'kiddo/Read/GetWalletListWeb'
Vue.prototype.$GenerateEWallet = 'kiddo/Read/GenerateEWallet'


//FindTutor
Vue.prototype.$GetFindTutorDetail = 'kiddo/Read/GetFindTutorDetail'
Vue.prototype.$SetSchedule = 'kiddo/insert/TeacherSetSchedule'
Vue.prototype.$DeleteTeacherSubjectGrade = 'kiddo/insert/DeleteTeacherSubjectGrade'

//Teacher Profile
Vue.prototype.$TeacherProfile = 'kiddo/Read/UserProfile'
Vue.prototype.$TeacherSubjectGrade = 'kiddo/Read/TeacherSubjectGrade'
Vue.prototype.$TeacherAcademiceProfile = 'kiddo/Read/TeacherAcademiceProfile'
Vue.prototype.$TeacherWorkBackground = 'kiddo/Read/TeacherWorkBackground'
Vue.prototype.$TeacherAreasOfExpertise = 'kiddo/Read/TeacherAreasOfExpertise'
Vue.prototype.$TeacherProfessional = 'kiddo/Read/TeacherProfessional'
Vue.prototype.$TeacherLanguage = 'kiddo/Read/TeacherLanguage'
Vue.prototype.$TeacherSalary = 'kiddo/read/GetTeacherSalary'
Vue.prototype.$ScheduleTeacherWeb = 'kiddo/read/TeacherTimeTableWeb'
Vue.prototype.$QuizTeacherLeaderboardAll = 'kiddo/read/QuizTeacherLeaderBoardsAll'
Vue.prototype.$ListEwallet = 'kiddo/read/getwalletlist'
Vue.prototype.$QuizTeacher = 'kiddo/read/QuizCount'
Vue.prototype.$CountQuizQuizStudent = 'kiddo/read/CountQuizStudent'
Vue.prototype.$StudentProfileById = 'kiddo/Read/GetStudentProfileByUserId'

//Create or Edit Teacher Profile
Vue.prototype.$InsertUpdateProfessionalProfile = 'kiddo/Insert/TeacherProfessionalProfileCreatedEdit'
Vue.prototype.$InsertUpdateAcademiceProfile = 'kiddo/Insert/TeacherAcademicProfileCreatedEdit'
Vue.prototype.$InsertUpdateAreaofExpertises = 'kiddo/Insert/TeacherAreasOfExpertiseCreatedEdit'
Vue.prototype.$InsertUpdateWorkBackground = 'kiddo/Insert/TeacherWorkBackgroundCreatedEdit'

Vue.prototype.$InsertNewSchedule = 'kiddo/Insert/CreateScheduleByTeacher'
Vue.prototype.$UpdateSchedules = 'kiddo/insert/EditScheduleByTeacher'
Vue.prototype.$StudentFilterSubject = 'kiddo/Insert/StudentFilterSubject'
Vue.prototype.$TeacherConfirmClass = 'kiddo/Insert/TeacherConfirmClass'
Vue.prototype.$StudentResponse = 'kiddo/Insert/StudentResponse'
Vue.prototype.$RegisterStudent = 'kiddo/insert/RegisterStudent'
Vue.prototype.$RegisterManualStudent = 'kiddo/insert/RegisterManualStudent'
Vue.prototype.$RegisterManualStudentTc = 'kiddo/insert/RegisterManualStudentTc'
Vue.prototype.$NewSubject = 'kiddo/insert/NewSubject'
Vue.prototype.$InsertWaitingList = 'kiddo/insert/WaitingList'
Vue.prototype.$TeacherTeachSubject = 'kiddo/insert/TeacherTeachSubject'
Vue.prototype.$TeacherAddNewSubject = 'kiddo/insert/TeacherAddNewSubject'
Vue.prototype.$RegisterNewSubjectGrade = 'kiddo/insert/RegisterNewSubjectGrade'
Vue.prototype.$InsertStudentSchedule = 'kiddo/insert/STUDENTSCHEDULE'
Vue.prototype.$InsertDirectFindTutorOneToOne = 'kiddo/insert/DirectFindTutorOneToOne'
Vue.prototype.$InsertDirectFindTutorGrouping = 'kiddo/insert/DirectFindTutorGrouping'
Vue.prototype.$InsertStudentPackage = 'kiddo/insert/StudentPackageWeb'

Vue.prototype.$InsertFaq = 'kiddo/insert/Faq'

Vue.prototype.$UpdateWaiting = 'kiddo/update/WaitingList'
Vue.prototype.$UpdateAcceptJob = 'kiddo/update/AcceptJob'

Vue.prototype.$UpdateProfessionalProfile = 'kiddo/update/ProfessionalProfile'
Vue.prototype.$UpdateAreaOfExpertise = 'kiddo/update/AreaOfExpertise'
Vue.prototype.$TeacherDeleteSubject = 'kiddo/update/UpdateTeacherSubject'

Vue.prototype.$ContactUs = 'contact/index'
Vue.prototype.$RegisterPartner = 'kiddo/insert/Partner'

Vue.prototype.$LoginTeacher = 'kiddo/insert/LoginTeachers'
Vue.prototype.$LoginStudent = 'kiddo/insert/LoginStudents'
Vue.prototype.$ForgotPassword = 'kiddo/insert/ForgotPassword'
Vue.prototype.$ValidateForgotPasswordCode = 'kiddo/insert/ValidateForgotPasswordCode'
Vue.prototype.$ChangePassword = 'kiddo/insert/ChangePassword'

Vue.prototype.$EWalletSummary = 'kiddo/read/EWalletSummary'
Vue.prototype.$EWalletSummaryUnPaid = 'kiddo/read/EWalletSummaryUnPaid'
Vue.prototype.$EWalletSummaryBySubject = 'kiddo/read/EWalletSummaryBySubject'
Vue.prototype.$InsertReloadWallet = 'kiddo/insert/ReloadWallet'

Vue.prototype.$LoginToken = 'kiddo/insert/LoginTokenTuitionCenter'
Vue.prototype.$CheckEwalletAmount = 'kiddo/insert/checkEwalletAmount'
Vue.prototype.$VideoConference = 'kiddo/Read/GetVideoLinkScheduleWeb'
Vue.prototype.$NotificationUnSeenCount = 'kiddo/Read/NotificationUnSeenCount'

Vue.prototype.$CheckJoinClass = 'kiddo/Read/CheckingJoinClass'

Vue.prototype.$InsertRegistrationTuitionCenter = 'kiddo/insert/submitRegistrationTuitionCenter'

//Dashboard
Vue.prototype.$AllParentList = 'kiddo/Read/AllParentListAuthorize'
Vue.prototype.$AllStudentList = 'kiddo/Read/AllStudentAuthorize'
Vue.prototype.$StudentDetailByIdAuthorize = 'kiddo/Read/StudentDetailByIdAuthorize'
Vue.prototype.$StudentsDetailByParent = 'kiddo/Read/StudentsDetailByParent'
Vue.prototype.$ViewPaymentStudentById = 'kiddo/read/GetPaymentStudentTc'

//READ API tc
Vue.prototype.$AllTransaction = 'kiddo/read/EWalletSummary'
Vue.prototype.$RemainingTransaction = 'kiddo/read/EWalletSummaryByRemaining'
Vue.prototype.$ViewSubject = 'kiddo/read/GetSubjectTc'
Vue.prototype.$ViewPackage = 'kiddo/read/GetPackageTc'
Vue.prototype.$ListSubjectPerPackage = 'kiddo/read/GetListSubjectPerPackage'
Vue.prototype.$ViewStudent = 'kiddo/read/GetStudentTc'
Vue.prototype.$ViewStudentLoad = 'kiddo/read/GetStudentTcLoad'
Vue.prototype.$ViewStudentHome = 'kiddo/read/GetStudentTcHome'
Vue.prototype.$ViewStudentCount = 'kiddo/read/GetStudentTcCount'
Vue.prototype.$ViewTeacher = 'kiddo/read/GetTeacherTc'
Vue.prototype.$ViewTeacherCount = 'kiddo/read/GetTeacherTcCount'
Vue.prototype.$ViewAttendanceStudent = 'kiddo/read/GetAttendanceStudentTc'
Vue.prototype.$ViewAttendanceTeacher = 'kiddo/read/GetAttendanceTeacherTc'
Vue.prototype.$ViewPaymentStudent = 'kiddo/read/GePaymentStudentTc'
Vue.prototype.$ViewPaymentTeacher = 'kiddo/read/GetPaymentTeacherTc'
Vue.prototype.$ViewSchedule = 'kiddo/read/GetScheduleTc'
Vue.prototype.$ViewScheduleByDate = 'kiddo/read/GetScheduleTcByDate'
Vue.prototype.$ViewNotification = 'kiddo/read/GetNotificationTc'
Vue.prototype.$ViewProfilePictureAdmin = 'kiddo/read/GetProfilePictureTc'
Vue.prototype.$ListGradeTc = 'kiddo/read/GetGradeListByTc'
Vue.prototype.$ListClassTc = 'kiddo/read/GetClassListByTc'
Vue.prototype.$GetScheduleBySubjectId = 'kiddo/read/GetScheduleTcBySubId'
Vue.prototype.$GetListWeklySchedule = 'kiddo/read/GetListWeklySchedule'
Vue.prototype.$GetWeeklyScheduleById = 'kiddo/read/GetWeeklyScheduleById'
Vue.prototype.$GetStudentReportCard = 'kiddo/read/GetStudentReportCard'
Vue.prototype.$GetGradeClasses = 'kiddo/read/GetGradeClass'
Vue.prototype.$GetListTeacherBySubId = 'kiddo/read/GetListTeacherForSubjectId'
Vue.prototype.$GetListReportCardBySubId = 'kiddo/read/GetListReportCardBySubId'
Vue.prototype.$GetSubjectById = 'kiddo/read/GetSubjectTcById'
Vue.prototype.$GetRateTeacherById = 'kiddo/read/GetSubjectTeacherRateTcById'
Vue.prototype.$GetPackageById = 'kiddo/read/GetPackageTcById'
Vue.prototype.$GetListSubjectTc = 'kiddo/read/GetListSubjectByTc'
Vue.prototype.$GetListSubjectPackageTc = 'kiddo/read/GetListSubjectByPackageId'
Vue.prototype.$GetListStudentPackage = 'kiddo/read/GetListStudentPackage'
Vue.prototype.$GetRateType = 'kiddo/read/GetRateType'
Vue.prototype.$GetTeacherById = 'kiddo/read/GetTeacherById'
Vue.prototype.$GetScheduleById = 'kiddo/read/GetAttendanceByScheduleId'
Vue.prototype.$GetAdditionPaymentStudent = 'kiddo/read/GetAdditionalPaymentStudentTc'
Vue.prototype.$GetReceiptStudentPayment = 'kiddo/read/GetReceiptStudentPayment'
Vue.prototype.$GetAdditionalPaymentTeacher = 'kiddo/read/GetAdditionalPaymentTeacher'
Vue.prototype.$GetDetailTeacher = 'kiddo/read/GetDetailTeachers'
Vue.prototype.$GetSlipTeacher = 'kiddo/read/GetSlipTeacher'
Vue.prototype.$EditSchedule = 'kiddo/Read/ScheduleDetails'
Vue.prototype.$GetMassNotification = 'kiddo/Read/GetMassNotification'
Vue.prototype.$GetRegistrationFee = 'kiddo/Read/GetRegistrationFeeTc'
Vue.prototype.$GetDetailRegistrationFee = 'kiddo/Read/GetDetailRegistrationFeeTc'
Vue.prototype.$GetListEpayTrackData = 'kiddo/Read/GetListEpayTrack'
Vue.prototype.$GetListEpayTrackDataByDateRange = 'kiddo/Read/GetListEpayTrackByDateRange'
Vue.prototype.$GetListNotificationMass = 'kiddo/Read/GetListNotificationMass'
Vue.prototype.$GetListPeopleNotificationMass = 'kiddo/Read/GetListPeopleNotificationMass'
Vue.prototype.$GetListAllPeople = 'kiddo/Read/GetListPeople'
Vue.prototype.$GetListBillingSubscription = 'kiddo/Read/ListBillingSubscription'
Vue.prototype.$GetCheckSubsLoginAdmin = 'kiddo/Read/CheckSubsLoginAdmin'
Vue.prototype.$GetListCountry = 'kiddo/Read/GetCountry'
Vue.prototype.$ViewScheduleByMonthYear = 'kiddo/Read/GetScheduleTcByMonth'

//INSERT API TC
Vue.prototype.$InsertNewSubjectTc = 'kiddo/insert/CreateSubject'
Vue.prototype.$InsertNewSubjectTcAdmin = 'kiddo/insert/CreateNewSubjectAdminDashboard'
Vue.prototype.$InsertNewGradeClassTc = 'kiddo/insert/CreateGradeClass'
Vue.prototype.$InsertNewScheduleBySubId = 'kiddo/insert/CreateWeeklySchedules'
Vue.prototype.$InsertNewReportCard = 'kiddo/insert/CreateReportCard'
Vue.prototype.$InsertAssignTeacher = 'kiddo/insert/CreateAssignTeacherToSubject'
Vue.prototype.$InsertSchedule = 'kiddo/insert/CreateSchedulesTc'
Vue.prototype.$InsertScheduleNew = 'kiddo/insert/CreateSchedulesTcNew'
Vue.prototype.$InsertPackage = 'kiddo/insert/CreatePackageTc'
Vue.prototype.$InsertAssignSubject = 'kiddo/insert/InsertAssignSubjectPackage'
Vue.prototype.$InsertAssignStudentPackage = 'kiddo/insert/InsertAssignStudentPackage'
Vue.prototype.$InsertRegisterAdmin = 'kiddo/insert/RegisterAdmin'
Vue.prototype.$InsertImportStudent = 'kiddo/insert/ImportStudentTc'
Vue.prototype.$InsertRegisterTeacher = 'kiddo/insert/RegisterTeacher'
Vue.prototype.$InsertAddPaymentStudent = 'kiddo/insert/CreateAdditionalPaymentStudent'
Vue.prototype.$InsertAddPaymentTeacher = 'kiddo/insert/CreateAdditionalPaymentTeacher'
Vue.prototype.$InsertSetPaymentStudent = 'kiddo/insert/CreateSetPaymentStudent'
Vue.prototype.$InsertSetPaymentTeacher = 'kiddo/insert/CreateSetPaymentTeacher'
Vue.prototype.$InsertBroadcast = 'kiddo/insert/SendBroadcast'
Vue.prototype.$InsertMassGroup = 'kiddo/insert/CreateMassGroup'
Vue.prototype.$InsertGenerateInvoice = 'kiddo/insert/GenerateInvoice'
Vue.prototype.$InsertPeople = 'kiddo/insert/InsertPeople' 
Vue.prototype.$InsertNotificationMass = 'kiddo/insert/SendMassNotification' 
Vue.prototype.$UpdateSubscribePackageFree = 'kiddo/update/UpdateRenewPackage'
Vue.prototype.$UpdateRenewPackagePay = 'kiddo/update/UpdateRenewPackagePayment'
Vue.prototype.$UpdatePaidSubscription = 'kiddo/update/UpdatePaidSubscription'

Vue.prototype.$DeleteWeeklySchedule = 'kiddo/delete/RemoveWeeklySchedule'
Vue.prototype.$DeleteGrade = 'kiddo/delete/RemoveGrade'
Vue.prototype.$DeleteSubject = 'kiddo/delete/RemoveSubject'
Vue.prototype.$DeleteTeacherOnSubject = 'kiddo/delete/RemoveTeacherSubject'
Vue.prototype.$DeleteReportCard = 'kiddo/delete/RemoveReportCards'
Vue.prototype.$DeleteAddPayment = 'kiddo/delete/DeleteAddPayment'
Vue.prototype.$DeleteTeacherRate = 'kiddo/delete/RemoveTeacherRate'
Vue.prototype.$DeleteTuitionPackage = 'kiddo/delete/RemoveTuitionPackage'
Vue.prototype.$DeleteSubjectTuitionPackage = 'kiddo/delete/RemoveSubjectTuitionPackage'
Vue.prototype.$DeleteStudentPackage = 'kiddo/delete/RemoveStudentPackage'
Vue.prototype.$DeleteAdditionalPaymentStudent = 'kiddo/delete/RemoveAdditionalPaymentStudent'
Vue.prototype.$DeletePaymentStudent = 'kiddo/delete/RemoveStudentPayment'
Vue.prototype.$DeleteSchedule = 'kiddo/delete/RemoveSchedule'
Vue.prototype.$DeleteUserMassNoti = 'kiddo/delete/RemoveUserMassNotification'
Vue.prototype.$DeleteGroupMass = 'kiddo/delete/RemoveGroupMassNotification'
Vue.prototype.$RemovePurchase = 'kiddo/delete/RemovePurchase'

Vue.prototype.$UpdateReportCard = 'kiddo/update/ReportCards'
Vue.prototype.$UpdateTuitionSubject = 'kiddo/update/TuitionSubject'
Vue.prototype.$UpdateTuitionPackage = 'kiddo/update/TuitionPackage'
Vue.prototype.$UpdateDiscount = 'kiddo/update/InsertDiscount'
Vue.prototype.$UpdateManualStudent = 'kiddo/update/EditRegistrationStudent'
Vue.prototype.$UpdateStatusStudent = 'kiddo/update/EditStatusStudent'
Vue.prototype.$UpdateTeacher = 'kiddo/update/EditTeacher'
Vue.prototype.$UpdateTeacherStatus = 'kiddo/update/EditTeacherStatus'
Vue.prototype.$UpdateStudentAttendance = 'kiddo/update/EditStudentAttendance'
Vue.prototype.$UpdateTeacherAttendance = 'kiddo/update/EditeacherAttendance'
Vue.prototype.$UpdateTeacherAttendanceBackup = 'kiddo/update/EditeacherAttendanceBackup'
Vue.prototype.$UpdateRefreshAttendance = 'kiddo/update/RefreshAttendance'
Vue.prototype.$UpdateSchedules = 'kiddo/insert/EditScheduleByTeacher'
Vue.prototype.$UpdateRegistrationFee = 'kiddo/update/EditRegistrationFee'
Vue.prototype.$GetAttendanceEwallet = 'kiddo/read/CheckAttendanceEwallet'

Vue.prototype.$FindTutorMsgAnalysis = 'kiddo/read/FindTutorMsgAnalysis'
Vue.prototype.$FindTutorStillOpen = 'kiddo/read/FindTutorStillOpen'
Vue.prototype.$FindTutorTeacherApply = 'kiddo/read/FindTutorTeacherApply'
Vue.prototype.$GetSubjectTcWeb = 'kiddo/read/GetSubjectTcWeb'

Vue.prototype.$GetTuitionPaymentStudent = 'kiddo/read/TuitionPaymentStudent'
Vue.prototype.$GetCheckTcPackage = 'kiddo/read/GetCheckTcPackage'

Vue.prototype.$FindTutorListToRespondByLimitAuthorize = 'kiddo/Read/FindTutorListToRespondByLimitAuthorize'
Vue.prototype.$FindTutorListToRespondByLimitAuthorizeAll = 'kiddo/Read/FindTutorListToRespondByLimitAuthorizeAll'
Vue.prototype.$FindTutorListWaitingByLimitAuthorizeAll = 'kiddo/Read/FindTutorListWaitingByLimitAuthorizeAll'

Vue.prototype.$TotalPaidAndUnpaidByTc = 'kiddo/Read/TotalPaidAndUnpaidByTc'
Vue.prototype.$AskiddoListAll = 'kiddo/Read/AskiddoListAll'
Vue.prototype.$ScheduleByWeek = 'kiddo/Read/SchedulesStudentsByTc'
Vue.prototype.$AttendanceOverview = 'kiddo/Read/AttendanceOverview'
Vue.prototype.$AllNotificationLimitAuthorizeByWebTc = 'kiddo/Read/AllNotificationLimitAuthorizeByWebTc'

Vue.prototype.$GetAttendanceReport = 'kiddo/Read/GetAttendanceReport'
Vue.prototype.$GetAttendanceReportTeacher = 'kiddo/Read/GetAttendanceReportTeacher'
Vue.prototype.$GetDataPaginate = 'kiddo/Read/GetDataPaginate'
Vue.prototype.$GetDataPaginateFirst5 = 'kiddo/Read/GetDataPaginateFirst5'
Vue.prototype.$GetDataPaginateSubjectFirst5 = 'kiddo/Read/GetDataPaginateSubjectFirst5'
Vue.prototype.$GetCountSubjectPaginate = 'kiddo/Read/GetCountSubjectPaginate'
Vue.prototype.$GetSubjectTcLoop = 'kiddo/Read/GetSubjectTcLoop'
Vue.prototype.$ViewStudentTcLoop = 'kiddo/read/GetStudentTcLoop'

Vue.prototype.$AssignTeacher = 'kiddo/update/EditAssignTutor'
Vue.prototype.$UploadTcProfilePhoto = 'kiddo/filetransfer/UploadTcProfilePhoto'
Vue.prototype.$UploadPackage = 'kiddo/filetransfer/UploadPackage'

Vue.prototype.$CreateNewSubject = 'kiddo/insert/CreateNewSubject'
Vue.prototype.$CreateNewExam = 'kiddo/insert/CreateNewExam'
Vue.prototype.$FindTutorList = 'kiddo/read/FindTutorList'
Vue.prototype.$GetTeacherCountry = 'kiddo/read/GetTeacherCountry'

Vue.prototype.$ListTc = 'kiddo/read/GetListTc'
Vue.prototype.$ListTeacherActive = 'kiddo/read/GetListTcActive'
Vue.prototype.$GetTeacherCV = 'kiddo/read/GetTeacherCV'

Vue.prototype.$GetScheduleTcByCurrentYear = 'kiddo/read/GetScheduleTcByCurrentYear'
Vue.prototype.$EditDetailStudent = 'kiddo/update/EditDetailStudent'


Vue.prototype.$GetTotalTodayVisitor = 'kiddo/read/GetTotalTodayVisitor'
Vue.prototype.$GetLastWeekVisits = 'kiddo/read/GetLastWeekVisits'
Vue.prototype.$GetMonthlyChartData = 'kiddo/read/GetMonthlyChartData'
Vue.prototype.$GetThisWeekVisits = 'kiddo/read/GetThisWeekVisits'

Vue.prototype.$UpdatePickiddoUserProfileImage = 'kiddo/update/UpdatePickiddoUserProfileImage'

Vue.prototype.$EditTuitionCenter = 'kiddo/update/UpdateTuitionCenter'


//flyhigh
Vue.prototype.$GetListProduct = 'kiddo/read/GetListProduct'
Vue.prototype.$GetListPaymentProduct = 'kiddo/read/GetListTransactionPurchased'
Vue.prototype.$GetStudentTcWithLoose = 'kiddo/read/GetStudentTcWithLoose'
Vue.prototype.$GetListGradePackage = 'kiddo/read/GetListGradeProduct'
Vue.prototype.$GetListSubGradePackage = 'kiddo/read/GetListSubGradeProduct'
Vue.prototype.$GetListProductGradeSubGrade = 'kiddo/read/GetListProductGradeSubGrade'
Vue.prototype.$GetScheduleTcFlyhighs = 'kiddo/read/GetScheduleTcFlyhigh'
Vue.prototype.$GetListModuleFile = 'kiddo/read/GetListModuleFiles'

Vue.prototype.$DeleteListGrade = 'kiddo/delete/RemoveListGrade'
Vue.prototype.$DeleteModule = 'kiddo/delete/DeleteModule'


Vue.prototype.$UpdateStatusProduct = 'kiddo/update/UpdateStatusProduct'
Vue.prototype.$UploadModuleFile = 'aws/UploadModuleFile'

Vue.prototype.$AssignModuleFiles = 'aws/AssignModuleFiles'

Vue.prototype.$UploadArticle = 'aws/UploadArticleFile'
Vue.prototype.$UploadMemo = 'aws/UploadMemo'
Vue.prototype.$UploadFileSlide = 'aws/UploadFileSlide'
Vue.prototype.$UploadFileActivity = 'aws/UploadFileActivity'
Vue.prototype.$UploadFilePoster = 'aws/UploadFilePoster'



Vue.prototype.$InsertArticle = 'kiddo/insert/submitArticles'
Vue.prototype.$GetListModuleFile = 'kiddo/read/GetListModuleFiles'
Vue.prototype.$GetListArticles = 'kiddo/read/GetListArticle'
Vue.prototype.$GetBannerView = 'kiddo/read/GetBanner'
Vue.prototype.$GetListMemo = 'kiddo/read/GetListMemo'
Vue.prototype.$GetListYoutube = 'kiddo/read/GetListYoutube'
Vue.prototype.$GetListSlidePromotion = 'kiddo/read/GetListSlidePromotion'
Vue.prototype.$GetListPoster = 'kiddo/read/GetListPoster'
Vue.prototype.$GetListAktiviti = 'kiddo/read/GetListAktiviti'
Vue.prototype.$GetTotalAmountPerMonth = 'kiddo/read/GetTotalAmountPerMonth'
Vue.prototype.$GetTotalAmountPerProduct = 'kiddo/read/GetTotalAmountPerProduct'
Vue.prototype.$GetTotalAmountPerWeekGroupDate = 'kiddo/read/GetTotalAmountPerWeekGroupDate'
Vue.prototype.$GetTotalAmountPerMonthGroupDate = 'kiddo/read/GetTotalAmountPerMonthGroupDate'
Vue.prototype.$GetTotalAmountPerYearGroupDate = 'kiddo/read/GetTotalAmountPerYearGroupDate'
Vue.prototype.$GetTotalAmountPerDateGroupHour = 'kiddo/read/GetTotalAmountPerDateGroupHour'
Vue.prototype.$GetTotalAmountCustomDate = 'kiddo/read/GetTotalCustomDate'
Vue.prototype.$GetListAllTransaction = 'kiddo/read/GetListAllTransaction'
Vue.prototype.$GetListCoupon = 'kiddo/read/GetListCoupon'
Vue.prototype.$GetDetailAffiliate ='kiddo/read/GetDetailAffiliate'
Vue.prototype.$GetListAffiliate ='kiddo/read/GetListAffiliate'
Vue.prototype.$GetListAffiliateByAgent ='kiddo/read/GetListTransactionByAgent'
Vue.prototype.$GetListUser ='kiddo/read/GetListUser'

Vue.prototype.$SubmitVCZoomDetails = 'kiddo/insert/submitVCZoomDetails'

Vue.prototype.$CreateBannerText = 'kiddo/insert/submitBanner'
Vue.prototype.$InsertMemo = 'kiddo/insert/submitMemo'
Vue.prototype.$InsertYoutube = 'kiddo/insert/submitYoutube'
Vue.prototype.$InsertSlidePromotion = 'kiddo/insert/submitSlidePromotion'
Vue.prototype.$InsertPoster = 'kiddo/insert/submitPoster'
Vue.prototype.$InsertAktiviti = 'kiddo/insert/submitAktiviti'
Vue.prototype.$InsertCoupon = 'kiddo/insert/SetCoupon'
Vue.prototype.$UpdateUserType = 'kiddo/insert/ChangeUserType'
Vue.prototype.$BlastScheduleAnnouncement = 'kiddo/insert/BlastScheduleAnnouncement'


Vue.prototype.$DeleteMemo = 'kiddo/delete/DeleteMemo'
Vue.prototype.$DeleteYoutube = 'kiddo/delete/DeleteYoutube'
Vue.prototype.$DeletePoster = 'kiddo/delete/DeletePoster'
Vue.prototype.$DeleteAktiviti = 'kiddo/delete/DeleteAktiviti'
Vue.prototype.$DeleteArticles = 'kiddo/delete/DeleteArticles'

Vue.prototype.$UpdateAssignAgent = 'kiddo/update/UpdateAssignAgent'


import VueComp from '@vue/composition-api'
Vue.config.productionTip = false
//use the vue-composition-api plugin
Vue.use(VueComp)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})

